'use strict';

import VerificacionComponent from './certificacion.verificacion.component';


// modulo para verificacion de certificacion PM y SHB
const Verificacion = angular
.module('app.certificacion.verificacion', [])
.component('certificacionVerificacion', VerificacionComponent)
      .config(($stateProvider, $urlRouterProvider, deviceDetectorProvider) => {
        deviceDetectorProvider.addCustom("My_Custom_Detector",{or:["\\bChrome\\b","\\bFirefox\\b","\\bSafari\\b"]});
  $stateProvider
  .state('certificacionVerificacion', {
    url: '/certificacion/verificar',
    component: 'certificacionVerificacion'
  })
  ;
  $urlRouterProvider.otherwise('/');

})
.name;

export default Verificacion;



// WEBPACK FOOTER //
// ./src/app/components/admin/certificacion.verificacion/certificacion.verificacion.module.js